const { REACT_APP_BASE_URL } = process.env;

export const createVendor = (vendorId: string, vendorName: string): Promise<Response> => {
    return fetch(`${REACT_APP_BASE_URL}vendors/createvendor`, {
        method: 'POST',
        body: JSON.stringify({
            vendorId: vendorId,
            vendorName: vendorName,
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    });
};
